import { DocumentNode, useMutation } from '@apollo/client';
import { FORM_ERROR } from 'final-form';

import { AddSessionNoteMutation, AddSessionNoteMutationVariables, AddStudentNoteMutation, AddStudentNoteMutationVariables, NoteOriginType, NoteTypeEnum } from '../../../../__generated__/graphql';
import { ApiValidationError, mapApiFieldValidationErrors } from '../../../../components/Form';
import { ApiUnknownError } from '../../../../components/Form/mapApiFieldValidationErrors';
import { useWorkListContext } from '../../../../context/WorkListsContext';
import { useSlideInContext } from '../../../../context/SlideInContext';
import { SESSION_NOTES_QUERY } from '../../../DashboardPages/components/HistoryTable/HistoryTable';
import { ADD_STUDENT_NOTE_MUTATION } from '../AddNote/AddNote';
import { useStudentContext } from '../../../../context/studentContext';
import ReferralForm from './ReferralForm';
import { STUDENT_NOTES_QUERY } from '../../../StudentPages/components/StudentNoteTable';
import { useParams } from 'react-router';
export const formatBody = (value: string) => {
    return value
        .replace(/_/g, ' ') // Replace underscores with spaces
        .replace(/\b\w/g, (match) => match.toUpperCase()) // Capitalize first letter of each word
        .replace(/\B\w/g, (match) => match.toLowerCase()); // Lowercase the remaining characters
}
const formattedReferralTypes = {
    [NoteTypeEnum.Referral]: "Referral Made",
    [NoteTypeEnum.NoReferral]: "No referral needed",
    [NoteTypeEnum.Monitoring]: "Monitoring in house"
}

export default function MakeAReferral() {
    const [addStudentNoteMutation] = useMutation<AddStudentNoteMutation, AddStudentNoteMutationVariables>(ADD_STUDENT_NOTE_MUTATION);
    const { toggleDrawer } = useSlideInContext();
    const { session } = useWorkListContext();
    const { studentData } = useStudentContext();
    const { sid } = useParams();
    const isSessionSpecific = (window.location.pathname.includes("notes") && !window.location.pathname.includes("children")) || (window.location.pathname.includes("session"))
    const noteOrigin = isSessionSpecific ? window.location.pathname.includes("notes") ? NoteOriginType.HistoryTable : NoteOriginType.ResultsTable : NoteOriginType.NotesTable
    const queriesToRefetch: { query: DocumentNode; variable?: any }[] = [
        session?.id ? {
            query: SESSION_NOTES_QUERY,
            variables: {
                sessionId: session?.id
            }
        } : null,
        studentData?.id ? {
            query: STUDENT_NOTES_QUERY,
            variables: {
                studentId: studentData?.id
            }
        } : null].filter(Boolean) as { query: DocumentNode; variables: any }[];

    const handleSubmitReferral = async (values: any) => {
        const _adjustedNote = formattedReferralTypes[values.noteType as keyof typeof formattedReferralTypes] || "";
        const response = await addStudentNoteMutation({
            variables: {
                studentId: studentData?.id ?? sid,
                type: values.noteType,
                origin: noteOrigin,
                body: `${_adjustedNote} ${values.note ? ": " + values.note : ""}`
            },
            refetchQueries: queriesToRefetch
        })
        if (response.data?.addStudentNote.errors) {
            const validationError = response.data.addStudentNote.errors
                .find(e => e.__typename === "ValidationError") as ApiValidationError;
            if (validationError.errors) {
                const fieldErrors = validationError
                    ? mapApiFieldValidationErrors(validationError)
                    : null;

                return fieldErrors;
            }
            const unknownError = response.data.addStudentNote.errors
                .find(e => e.__typename === 'UnknownError') as ApiUnknownError;

            if (unknownError) {
                return { [FORM_ERROR]: unknownError.message }
            }
        }
        toggleDrawer();
    }
    return (
        <div>
            <ReferralForm
                onCancel={() => toggleDrawer()}
                onSubmit={async values => { handleSubmitReferral(values) }}
            />
        </div>
    )
}
